import { Flash, Text, Section, Checkbox, Select, FormField, Box } from '@acast/decibel';
import T from 'prop-types';
import React from 'react';
import ShowFlags from 'shared/helpers/flags';

const DEFAULT_EPISODE_COUNT = 7;

function selectFlag(show, flagName) {
  return Array.isArray(show.flags) && show.flags.find(f => f.name === flagName);
}

const AcastPlusSettings = ({ show, onChange, metaFunc }) => {
  const fieldProps = propName => ({
    propName,
    meta: metaFunc(propName),
  });

  const options = [];

  while (options.length < 30) {
    options.push({
      value: options.length + 1,
      label: String(options.length + 1),
    });
  }

  const currentFlag = selectFlag(show, ShowFlags.BackCatalog);
  const isEnabled = currentFlag !== undefined;
  const selectedValue = isEnabled ? currentFlag.count : 1;

  const toggleBackCatalog = ({ target: { checked } }) => {
    let newFlags = show.flags;

    if (checked) {
      newFlags = [
        ...newFlags,
        {
          name: ShowFlags.BackCatalog,
          count: DEFAULT_EPISODE_COUNT,
        },
      ];
    } else {
      newFlags = newFlags.filter(flag => flag.name !== ShowFlags.BackCatalog);
    }
    onChange('flags', newFlags);
  };

  const setEpisodeCount = value => {
    const newFlags = show.flags.map(flag => {
      if (flag.name === ShowFlags.BackCatalog) {
        return {
          name: ShowFlags.BackCatalog,
          count: value,
        };
      }
      return flag;
    });
    onChange('flags', newFlags);
  };

  return (
    <Section>
      <Text variant="h3">Acast+ Settings</Text>
      <Box mb={6}>
        <Checkbox
          id={show.id}
          checked={isEnabled}
          onChange={toggleBackCatalog}
          label="Enable Back Catalog for this show"
        />
      </Box>
      {isEnabled && (
        <FormField label="Number of latest episodes to be publicly available:">
          <Select {...fieldProps('flags')} value={selectedValue} onChange={setEpisodeCount}>
            {options.map(option => (
              <Select.Option key={option.value} value={option.value} disabled={option.disabled}>
                {option.label}
              </Select.Option>
            ))}
          </Select>
        </FormField>
      )}
      {!isEnabled && (
        <Flash intent="primary">
          Episodes in the back catalogue will only be accessible to paying Acast+ listeners.
        </Flash>
      )}
    </Section>
  );
};

AcastPlusSettings.propTypes = {
  show: T.object,
  onChange: T.func,
  metaFunc: T.func,
};

export default AcastPlusSettings;
